import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack } from '@mui/material';
// components
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
import { MHidden } from '../../components/@material-extend';
//
import sidebarConfig, { test_sidebarConfig } from './SidebarConfig';
import account from '../../_mocks_/account';
import Footer from '../../components/Footer';

import { GetUserInfo } from './index';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH
  }
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: theme.shape.borderRadiusSm,
  backgroundColor: theme.palette.grey[200]
}));

// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  let [userInfo, setUserInfo] = useState(null);
  useEffect(() => {

    GetUserInfo().then(userInfo => {
      if (userInfo != null) {
        //let { id, Account, NickName, Mobile, Mobile2, Email, HeadPortrait, IsMain } = ;
        setUserInfo(JSON.parse(userInfo.amr[0]))
      }
    });
  }, []);

  if (userInfo == null) return null;

  const GetUserNick = () => {
    var u = userInfo;
    if (u.NickName.length > 0) return u.NickName;
    if (u.Mobile.length > 0) return u.Mobile;
    if (u.Email.length > 0) return u.Email;
    if (u.Mobile2.length > 0) return u.Mobile2;
    return 'No Name';
  }
  const GetCompanyName = () => {
    var u = userInfo;
    if (u.Identity.source.Name.length > 0) return u.Identity.source.Name;
    return GetUserNick();
  }

  const GetCompanyAddress = () => {
    var uI = userInfo.Identity;
    return `${uI.extend.Province}${uI.extend.City}${uI.extend.Area}${uI.source.Address}`;
  }

  const GetCompanyLogo = () => {
    var uI = userInfo.Identity;
    return uI.extend.CompanyLogo;
  }

  const renderContent = (
    <Scrollbar
      sx={{
        height: '100%',
        '& .simplebar-content': { height: '100%', display: 'flex', flexDirection: 'column' }
      }}
    >
      <Box sx={{ px: 2.5, py: 3 }}>
        <Box sx={{ display: 'inline-flex' }}>
          <Logo />
        </Box>
      </Box>

      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none" component={RouterLink} to="#">
          <AccountStyle>
            <Avatar src={GetCompanyLogo()} />
            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {GetCompanyName()}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {GetCompanyAddress()}
              </Typography>
            </Box>
          </AccountStyle>
        </Link>
      </Box>

      {/* <NavSection navConfig={global.isDevelopment ? sidebarConfig.concat(test_sidebarConfig) : sidebarConfig} /> */}
      <NavSection navConfig={sidebarConfig} />

      {/* <Box sx={{ flexGrow: 1 }} /> */}

      {/* <Box sx={{ px: 2.5, pb: 3, mt: 10 }}>
        <Stack
          alignItems="center"
          spacing={3}
          sx={{
            p: 2.5,
            pt: 5,
            borderRadius: 2,
            position: 'relative',
            bgcolor: 'grey.200'
          }}
        >
          <Box
            component="img"
            src="/static/illustrations/illustration_avatar.png"
            sx={{ width: 100, position: 'absolute', top: -50 }}
          />

          <Box sx={{ textAlign: 'center' }}>
            <Typography gutterBottom variant="h6">
              Get more?
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              From only $69
            </Typography>
          </Box>

          <Button
            fullWidth
            href="https://material-ui.com/store/items/minimal-dashboard/"
            target="_blank"
            variant="contained"
          >
            Upgrade to Pro
          </Button>
        </Stack>
      </Box> */}
    </Scrollbar>
  );

  return (
    <RootStyle>
      <MHidden width="lgUp">
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH }
          }}
        >
          {renderContent} 
        </Drawer>
      </MHidden>

      <MHidden width="lgDown">
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default'
            }
          }}
        >
          {renderContent}
          <Footer />
        </Drawer>
      </MHidden>
    </RootStyle>
  );
}
